/**
 * Grace window around body scroll-lock release.
 *
 * Fullscreen layers (the lawn-size map, the chat widget) lock the body with
 * `position: fixed` and restore the scroll position with a programmatic
 * `window.scrollTo` on exit. That restoration scroll is indistinguishable from
 * a user scroll to listeners like useExitIntent, and it lands AFTER the lock
 * styles are cleared — so a `position === 'fixed'` check alone cannot filter
 * it. The releasing component marks the release; scroll-intent consumers
 * ignore scroll events for a short window afterwards.
 */

const GRACE_MS = 1000

let releasedUntil = 0

/** Call immediately before restoring the scroll position on lock release. */
export function markScrollLockReleased(): void {
  releasedUntil = Date.now() + GRACE_MS
}

/** True while scroll events should not be treated as user scroll intent. */
export function inScrollLockGrace(): boolean {
  return Date.now() < releasedUntil
}
